module.exports = __webpack_public_path__ + "f553ce706ba24b7f141925c19110a65a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fair/business2.png
// module id = ./assets/images/fair/business2.png
// module chunks = 0